<shared-info-box [homeLink]="homeLink" [src]="imgSrc" [description]="description">
    {{title}}
</shared-info-box>